import { Button, Card, CardBody, CardHeader, Heading } from '@nrg/design-system';
import * as Sentry from '@sentry/react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

export default function RouteErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div style={{ padding: '2rem', display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <Card style={{ maxWidth: 480 }}>
          <CardHeader>
            <Heading level={2}>
              {error.status} {error.statusText}
            </Heading>
          </CardHeader>
          <CardBody>
            <p>{error.data ?? 'The page you requested could not be loaded.'}</p>
          </CardBody>
        </Card>
      </div>
    );
  }

  Sentry.captureException(error);

  return (
    <div style={{ padding: '2rem', display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
      <Card style={{ maxWidth: 480 }}>
        <CardHeader>
          <Heading level={2}>Unexpected error</Heading>
        </CardHeader>
        <CardBody>
          <p>Something went wrong. The error has been reported.</p>
          <Button
            variant="primary"
            onClick={() => window.location.reload()}
            style={{ marginTop: '1.5rem' }}
          >
            Reload
          </Button>
        </CardBody>
      </Card>
    </div>
  );
}
